// See `app/javascript/hub/README.md`
import MainMenuComponent from "../hub/MainMenuComponent";
import imageRotate from "../hub/image_rotate";

window.addEventListener("load", function() {
  MainMenuComponent();
  imageRotate();
})
